<template>
  <nav :class="sticky && 'sticky'">
    <Title tag="h4" theme="secondary" v-if="title">
      {{ title }}
    </Title>
    <List :class="['nav']">
      <li v-for="(item, index) in itemsNav.data" :key="index">
        <a
          role="button"
          :to="item.path"
          @click="handleClick(item.path)"
          :class="[
            'nav--link',
            item.active && 'active',
            item.disabled && 'disabled',
          ]"
        >
          {{ item.tag }}
          <Icon v-if="item.icon" :svg="item.icon" />
        </a>
      </li>
    </List>
  </nav>
</template>
<script>
import List from "@/components/ui/objects/List";
import Title from "@/components/ui/atoms/Title";
import Icon from "@/components/ui/icons/Icon";
import { reactive, ref } from "@vue/reactivity";
import { onMounted, onUnmounted } from "vue";
export default {
  components: {
    List,
    Title,
    Icon,
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    style: {
      type: String,
    },
    title: {
      type: String,
    },
    sticky: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const CURRENT_SECTION_INDEX = -1;
    let currentSectionIndex = ref(CURRENT_SECTION_INDEX);
    let itemsNav = reactive({
      data: props.items.map((item) => {
        const section = {
          tag: item.tag,
          path: item.path,
          active: false,
        };
        return section;
      }),
    });
    const setBoundings = () => {
      for (let i = 0; i < itemsNav.data.length; i++) {
        const item = document
          .querySelector(itemsNav.data[i].path)
          .getBoundingClientRect();
        if (80 >= Math.floor(item.top)) {
          if (currentSectionIndex.value != -1)
            itemsNav.data[currentSectionIndex].active = false;
          currentSectionIndex = i;
          itemsNav.data[i].active = true;
        } else {
          break;
        }
      }
    };
    //IF WE REQUEST DIRECTLY
    onMounted(() => {
      setBoundings();
    });
    const handleClick = (currentSection) => {
      const el = document.querySelector(currentSection);
      el && el.scrollIntoView({ behavior: "smooth" });
    };
    const handleScroll = () => {
      //const currentScrollPosition = window.scrollY;
      /*
      itemsNav.data.forEach((item, index) => {
        if (currentScrollPosition >= item.bounding.top) {
          if (currentSectionIndex.value != -1)
            itemsNav.data[currentSectionIndex].active = false;
          currentSectionIndex = index;
          item.active = true;
        } else item.active = false;
      });
      */
      /*
      for (let i = 0; i < itemsNav.data.length; i++) {
        if (currentScrollPosition >= itemsNav.data[i].top) {
          if (currentSectionIndex.value != -1)
            itemsNav.data[currentSectionIndex].active = false;
          currentSectionIndex = i;
          itemsNav.data[i].active = true;
        } else {
          break;
        }
      }
      */
      for (let i = 0; i < itemsNav.data.length; i++) {
        const item = document
          .querySelector(itemsNav.data[i].path)
          .getBoundingClientRect();
        if (80 >= Math.floor(item.top)) {
          if (currentSectionIndex.value != -1)
            itemsNav.data[currentSectionIndex].active = false;
          currentSectionIndex = i;
          itemsNav.data[i].active = true;
        } else {
          break;
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll);
    });
    return {
      handleClick,
      itemsNav,
      setBoundings,
    };
  },
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
$active: variables.$primary-color;
$noactive: lighten(variables.$primary-color, 45%);
//$active: #212121;
//$noactive: #616161;
.sticky {
  position: sticky;
  top: 100px;
}
.nav {
  &--link {
    display: block;
    padding: 0.5em 1.5em;
    text-decoration: none;
    color: currentColor;
    border-left: 3px solid $noactive;
    width: 100%;
    &.active {
      pointer-events: none;
      border-color: $active;
      color: $active;
    }
    &:hover {
      color: $active;
    }
  }
}
nav {
  padding-top: variables.$fs-l;
}
@media (min-width: 768px) {
  nav {
    padding-top: variables.$fs-md-l;
  }
}
</style>
